import { slicedToArray as _slicedToArray } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useCallback } from 'react';
import { useFormikContext } from 'formik';
import { Slider } from '../../Slider/component.js';
var RangeField = function RangeField(_ref) {
  var initialValue = _ref.initialValue,
    label = _ref.label,
    value = _ref.value,
    _ref$vertical = _ref.vertical,
    vertical = _ref$vertical === undefined ? false : _ref$vertical,
    _ref$minValue = _ref.minValue,
    minValue = _ref$minValue === undefined ? 0 : _ref$minValue,
    _ref$maxValue = _ref.maxValue,
    maxValue = _ref$maxValue === undefined ? 0 : _ref$maxValue,
    _ref$buttonInterval = _ref.buttonInterval,
    buttonInterval = _ref$buttonInterval === undefined ? 1 : _ref$buttonInterval,
    decreaseButton = _ref.decreaseButton,
    increaseButton = _ref.increaseButton,
    prefix = _ref.prefix,
    postfix = _ref.postfix,
    labels = _ref.labels,
    showButtonValue = _ref.showButtonValue;
  if (!useFormikContext()) {
    throw Error('The <RangeField /> component must be wrapped in a Formik context.  Did you mean to use the Core.Slider instead?');
  }
  value = initialValue !== null && initialValue !== undefined ? initialValue : 0;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    sliderValue = _useState2[0],
    setSliderValue = _useState2[1];
  var handleSliderChange = useCallback(function (newValue) {
    setSliderValue(newValue);
  }, []);
  return /*#__PURE__*/React.createElement(Slider, {
    "aria-label": label,
    variant: vertical ? 'vertical' : 'horizontal',
    step: buttonInterval,
    markers: labels ? [minValue, maxValue] : undefined,
    value: sliderValue,
    min: minValue,
    max: maxValue,
    prefix: prefix,
    postfix: postfix,
    controls: decreaseButton || increaseButton,
    tooltip: showButtonValue,
    onChange: handleSliderChange
  });
};
RangeField.displayName = "RangeField";
export { RangeField };